import { Conveyancing } from '@/service';

/**
 * @class @name Conveyancing
 * @description Exposes menu store module
 */
export default class ConveyancingStore {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	static get state() {
		return {};
	}

	/**
	 * @method @static @get @name getters
	 * @description Expose getters as an object, compatible with vue stores
	 */
	static get getters() {
		return {};
	}

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	static get mutations() {
		return {};
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @name loadConveyancingList
			 * @param {Object} context
			 * @param {Object} payload
			 */
			async loadConveyancingList(context, payload) {
				return Conveyancing.list(payload).then(({ data }) => data);
			},

			/**
			 * @name submitConveyancing
			 * @param {Object} context
			 * @param {Object} payload
			 */
			async submitConveyancing(context, payload) {
				return Conveyancing.post(payload).then(({ data }) => data);
			}
		};
	}
}
